import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import AaSequenceActions from 'molbio/aa-sequences/AaSequenceActions';
import AaSequenceStore from 'molbio/aa-sequences/AaSequenceStore';
import AminoAcidProperties from 'molbio/aa-sequences/AminoAcidProperties';
import Spinner from 'ui-library/Spinner';

class AaSequenceComplexPreviewConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [AaSequenceStore];

  enhanceProps(): EnhancedProps {
    const aminoAcids = [];
    for (const proteinId of this.props.proteinIds) {
      const aaSequence = this.aaSequenceStore().getAaSequenceById(proteinId);
      if (!aaSequence) {
        return {
          isLoading: true,
        };
      }
      aminoAcids.push(aaSequence.version.aminoAcids);
    }
    return {
      isLoading: false,
      combinedAminoAcids: aminoAcids.join(''),
    };
  }
}

interface Props {
  proteinIds: Array<string>;
}

type EnhancedProps = {isLoading: true} | {isLoading: false; combinedAminoAcids: string};

class AaSequenceComplexPreview extends React.Component<Props & EnhancedProps> {
  override componentDidMount(): void {
    this.props.proteinIds.forEach((proteinId) => {
      AaSequenceActions.open(proteinId, {});
    });
  }

  override render(): JSX.Element {
    if (this.props.isLoading) {
      return (
        <div className="text-center u-spacing-top">
          <div>Loading...</div>
          <Spinner />
        </div>
      );
    }
    return (
      <div className={css(styles.wrapper)}>
        <AminoAcidProperties aminoAcids={this.props.combinedAminoAcids} />
      </div>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default AaSequenceComplexPreviewConnector.connect(AaSequenceComplexPreview);
